export const createPortableEquipmentSlice = (set, get) => ({
  // Portable equipment charge (boolean flag)
  needsPortableEquipment: false,

  setNeedsPortableEquipment: (value) => {
    set({ needsPortableEquipment: value });
    // Trigger cart sync when portable equipment changes
    get().syncCartWithConfiguration();
  },

  togglePortableEquipment: () => {
    set((state) => ({
        needsPortableEquipment: !state.needsPortableEquipment
    }));
    // Trigger cart sync when portable equipment changes
    get().syncCartWithConfiguration();
  },
});
